export default __webpack_public_path__ + "85d0375aa61bf605ea59358e096a7353.svg";